import { Heading } from "@amzn/meridian";
import { Outlet } from "react-router-dom";
import "./admin.scss";

const Admin = () => {
  return (
    <div className="admin">
      <Heading level={1}>Admin</Heading>
      <Outlet />
    </div>
  );
};

export default Admin;
